import { render, staticRenderFns } from "./negativeMediaScoringTab.vue?vue&type=template&id=3d636bb8"
import script from "./negativeMediaScoringTab.vue?vue&type=script&lang=js"
export * from "./negativeMediaScoringTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports